// extracted by mini-css-extract-plugin
export default {"text_body":"svgAnimation_text_body__4rtW3","animate-stroke":"svgAnimation_animate-stroke__55Tne"};